module.exports = __webpack_public_path__ + "img/code.45c46c46.jpg";